var _defs, _rect, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentProductProofLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Luminous light system background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDE3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1E2",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F6FB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "url(#c)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 240,
    r: 470,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 920,
    r: 310,
    fill: "url(#b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#88C9FF",
    strokeOpacity: 0.28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 275,
    r: 240
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 275,
    r: 330
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 930 1460 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 0c-70 260-40 550 210 830"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentProductProofLuminousBackground);
export default __webpack_public_path__ + "static/media/custom-development-product-proof-luminous-background.0bde458a16ef669c5adad977e4fd23ac.svg";
export { ForwardRef as ReactComponent };